/**
 * Нормализация даты без времени (DATEONLY) в YYYY-MM-DD.
 * Важно: чистую строку 'YYYY-MM-DD' не прогонять через Date/dayjs —
 * иначе pg/JSON (`…T21:00:00.000Z` для +03) даёт сдвиг на день.
 */
export function asDateOnlyString(value: any): string | null {
	if (value == null || value === "") return null;
	if (value === "0000-00-00") return null;

	if (typeof value === "string") {
		const trimmed = value.trim();
		if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
	}

	const d = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(d.getTime())) return null;

	const yyyy = d.getFullYear();
	const mm = String(d.getMonth() + 1).padStart(2, "0");
	const dd = String(d.getDate()).padStart(2, "0");
	return `${yyyy}-${mm}-${dd}`;
}

/**
 * Время ЧЧ:ММ из строки/Date. Нельзя dayjs('21:55') — будет Invalid Date.
 */
export function formatTimeHm(value: any): string {
	if (value == null || value === "") return "";
	if (value instanceof Date && !Number.isNaN(value.getTime())) {
		const hh = String(value.getHours()).padStart(2, "0");
		const mm = String(value.getMinutes()).padStart(2, "0");
		return `${hh}:${mm}`;
	}
	const s = String(value).trim();
	if (!s || s === "--:--" || s === "00:00:00.000Z" || s === "Invalid Date") return "";
	// ISO: ...T21:55:00 или чистое 21:55 / 21:55:00
	const iso = s.match(/T(\d{1,2}):(\d{2})/);
	if (iso) return `${iso[1].padStart(2, "0")}:${iso[2]}`;
	const m = s.match(/^(\d{1,2}):(\d{2})/);
	if (!m) return "";
	return `${m[1].padStart(2, "0")}:${m[2]}`;
}
